import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'sortAlphaOnProp'
})
export class SortAlphaOnPropPipe implements PipeTransform {

  transform(value: any[], ...args: any[]): any {

    console.log("sort pipe", value, args)
    var sorted: any[]
    try {
      sorted = _.sortBy(value, args[0])
    } catch (error) {
      sorted = value
    }

    return sorted

  }

}
